import { type OnrApiMutationOptions, useOnrApi } from './mutation/useOnrApi.ts'

export interface ToggleEveningMobileEnabledApiVariables {
  regionId: string
}

export const useToggleEveningMobileEnabled = (
  options?: OnrApiMutationOptions<void, ToggleEveningMobileEnabledApiVariables>
) => useOnrApi<void, ToggleEveningMobileEnabledApiVariables>({ type: 'piloteToggleEveningMobileEnabled', ...options })
